import styled from 'styled-components';
import { Section } from 'src/components/GlobalUI';

export const PricingContent = styled(Section)`
	background: #121219;
	padding-bottom: 40px;
`;
